<div class="d-flex flex-column h-100 w-100 overflow-auto">
    <header>
      <h2 class="my-1 text-primary">
        Dashboard
      </h2>
      <hr class="mb-0" />
    </header>
    <lib-nav-tiles [routes]="routes" [linkPaths]="linkPaths"></lib-nav-tiles>
    <a [routerLink]="['/','test-data']" *ngIf="testing">Get test data</a>
</div>